import React, { useEffect, useState } from 'react'
import { 
  FiRefreshCw, 
  FiSearch, 
  FiFilter, 
  FiGrid,
  FiList,
  FiUsers,
  FiDollarSign,
  FiTrendingUp,
  FiTrendingDown,
  FiClock,
  FiCheckCircle,
  FiXCircle,
  FiAlertCircle,
  FiUser,
  FiMail,
  FiCalendar,
  FiTag,
  FiArrowUp,
  FiArrowDown,
  FiBarChart2,
  FiAward,
  FiStar,
  FiEye,
  FiFileText,
  FiCreditCard,
  FiPercent,
  FiWallet,
  FiBookOpen
} from "react-icons/fi";
import { 
  MdOutlinePayments, 
  MdOutlineAccountBalance,
  MdOutlineAttachMoney,
  MdOutlinePerson,
  MdOutlineCalendarToday,
  MdOutlineCheckCircle,
  MdOutlineCancel,
  MdOutlinePending,
  MdOutlineRefresh,
  MdOutlineSearch,
  MdOutlineFilter,
  MdOutlineReceipt,
  MdOutlineWallet,
  MdOutlineVisibility,
  MdOutlineDateRange,
  MdOutlineLocalOffer,
  MdOutlineSubscriptions
} from "react-icons/md";
import { IoWalletOutline, IoCashOutline, IoCardOutline, IoTimeOutline } from "react-icons/io5";
import Card from '../../components/Card/Card'
import card1icon from "../../public/images/card1.svg"
import card2icon from "../../public/images/card2.svg"
import card3icon from "../../public/images/card3.svg"
import ReferalTable from './Table/ReferalTable'
import ReferalCreateModal from './Modal/ReferalCreateModal'
import RewardCreateModal from './Modal/RewardCreateModal'
import { useDispatch, useSelector } from 'react-redux'
import { createReferral, } from '../../Redux/referralAndRewardSlice'
import SimpleDeleteModal from '../../components/Delete Modal/SimpleDeleteModal'
import { toast } from 'react-toastify'
import { deletePlan, getAllSubscriptionList, getTotalSubscriptionData, updateSubscriptionStatus } from '../../Redux/teacherSubscriptionSlice'
import { getAllPaymentList } from '../../Redux/paymentsAndTransactionSlice'
import { useNavigate } from 'react-router'

const feildsVlaue = { rewardname: "", rewardValue: "", condition: "" }

const TeachersSubscription = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selector = useSelector(state => state)
  const {
    teachersSubscription: {
      subscriptionListData = [],
      subscriptionListTotal = 0,
      getTotalSubscriptionDataData = {},
    } = {},
    paymentAndTransactionSlice: { netpaymentsAndTransaction = 0 } = {},
  } = selector || {};
  const [isDeleteModal, setIsDeleteModal] = useState(false)
  const [isCreateReferalModal, setIsCreateReferalModal] = useState(false)
  const [isCreateRewardModal, setIsCreateRewardModal] = useState(false)
  const [rewardCreateInputs, setRewardsCreateInput] = useState(feildsVlaue)
  const [cate, setCate] = useState()
  const [inputData, setInputData] = useState({
    referralName: "", count: "", discount: ""
  })
  const [keyword, setKeyword] = useState('')
  const [deleteData, setDeleteData] = useState(null)
  const [sortKey, setSortKey] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");

  const referralThead = [
    { label: '#', sortKey: null },
    { label: 'Title', sortKey: 'title' },
    { label: 'Description', sortKey: 'desc' },
    { label: 'Duration', sortKey: 'durationTypes' },
    { label: 'Created By', sortKey: "createdByUser.fullName" },
    { label: 'Status', sortKey: 'isDisable' },
    { label: 'Action', sortKey: null }
  ];

  const handleSort = (key) => {
    if (sortKey === key) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortKey(key);
      setSortOrder("asc");
    }
    setpageNo(1);
  };

  const [pageNo, setpageNo] = useState(1)
  const [size, setSize] = useState(10)
  const [errors, setErrors] = useState({});

  useEffect(() => {
    dispatch(getTotalSubscriptionData())
  }, [dispatch])

  useEffect(() => {
    dispatch(getAllPaymentList({
      keyWord: '',
      pageNo: 1,
      size: 10,
      fromDate: '',
      toDate: '',
      sortBy: 'createdAt',
      sortOrder: 'desc',
      status: '',
      type: '',
    }));
  }, [dispatch]);

  const deleteAction = (data) => {
    setIsDeleteModal(!isDeleteModal)
    setDeleteData(data)
  }

  const handleCreateReferal = (identify) => {
    { identify === 'REFERAL' ? setIsCreateReferalModal(!isCreateReferalModal) : setIsCreateRewardModal(!isCreateRewardModal) }
  }

  const toggleReferalCreateModal = () => {
    setIsCreateReferalModal(!isCreateReferalModal)
    setInputData({
      referralName: "", count: "", discount: ""
    })
    setCate()
  }

  const toggleRewardCreateModal = () => { setIsCreateRewardModal(!isCreateRewardModal) }

  const handleOnChnage = (e) => {
    const { name, value } = e.target
    setRewardsCreateInput({ ...rewardCreateInputs, [name]: value })
  }

  let payload = {
    "pageNo": pageNo,
    "size": size,
    "keyWord": keyword ? keyword : "",
    "sortKey": sortKey,
    "sortOrder": sortOrder
  }

  useEffect(() => {
    dispatch(getAllSubscriptionList(payload))
  }, [dispatch, keyword, pageNo, size, sortKey, sortOrder])

  let handlePageClick = (newPage) => {
    setpageNo(newPage?.selected + 1)
  }

  const handleRewardOnChange = (e) => {
    const { name, value } = e.target
    setInputData({ ...inputData, [name]: value })
  }

  const handleFormReset = () => {
    handleRewardOnChange({ target: { name: 'referralName', value: '' } });
    handleRewardOnChange({ target: { name: 'discount', value: '' } });
    handleRewardOnChange({ target: { name: 'count', value: '' } });
    setCate(null);
    setErrors({});
  }

  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!inputData?.referralName || inputData?.referralName.trim() === '') {
      formErrors.referralName = 'Referral name is required';
      isValid = false;
    }

    if (!inputData?.discount || inputData?.discount.trim() === '') {
      formErrors.discount = 'Discount is required';
      isValid = false;
    }

    if (!cate || (Array.isArray(cate) && cate.length === 0)) {
      formErrors.preference = 'At least one preference must be selected';
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  }

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const apiPayload = {
        ReferralCode: inputData.referralName,
        count: '1',
        percentDiscount: inputData.discount,
        courseCategory: Array.isArray(cate) ? cate.map(item => item.value) : [cate.value]
      };

      dispatch(createReferral({ Payload: apiPayload, forReferesh: payload })).then((res) => {
        if (res?.payload?.error) {
          toast.error(res?.payload?.message)
        } else {
          toast.success(res?.payload?.message)
          handleFormReset();
          toggleReferalCreateModal();
        }
      }).catch((err) => {
        toast.error(err)
        console.log("Error", err)
      })
    }
  }

  const toggleDeleteModal = () => { setIsDeleteModal(!isDeleteModal) }

  const handleDelete = () => {
    let deletePayload = {
      id: deleteData?._id
    }
    dispatch(deletePlan({ Payload: deletePayload, forReferesh: payload })).then((res) => {
      if (res?.payload?.error) {
        toast.error(res?.payload?.message)
      } else {
        toast.success(res?.payload?.message)
        setIsDeleteModal(false)
        setDeleteData(null)
      }
    }).catch((err) => {
      toast.error(err)
      console.log("Error", err)
    })
  }

  const handleToggle = (data) => {
    let togglePayload = {
      id: data?._id
    }
    dispatch(updateSubscriptionStatus({ Payload: togglePayload, forReferesh: payload }));
  };

  const viewAction = (data) => {
    navigate(`/app/teachers-subscription/${data._id}`)
  }

  // Get stats data
  const totalSubscription = getTotalSubscriptionDataData?.subscriptionPlan || 0;
  const totalSubscribers = getTotalSubscriptionDataData?.subscribers || 0;
  const totalEarning = Number(
    getTotalSubscriptionDataData?.totalAmount?.[0]?.totalAmount,
  ) || 0;
  const netRevenue = Number(netpaymentsAndTransaction) || 0;

  // Stats cards data
  const statsCards = [
    {
      title: 'Total Subscription',
      count: totalSubscription,
      icon: MdOutlineSubscriptions,
      color: 'from-blue-500 to-blue-600',
      img: card1icon,
      subtitle: 'Active plans'
    },
    {
      title: 'Total Subscribers',
      count: totalSubscribers,
      icon: FiUsers,
      color: 'from-emerald-500 to-emerald-600',
      img: card2icon,
      subtitle: 'Registered users'
    },
    {
      title: 'Total Earning',
      count: `$${totalEarning.toFixed(2)}`,
      icon: FiDollarSign,
      color: 'from-amber-500 to-amber-600',
      img: card3icon,
      subtitle: 'Revenue generated'
    },
    {
      title: 'Net Revenue',
      count: `$${netRevenue.toFixed(2)}`,
      icon: MdOutlineAccountBalance,
      color: 'from-cyan-500 to-cyan-600',
      subtitle: 'Revenue after deductions'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50/80">
      {/* Header Banner */}
      <div className="bg-gradient-to-r from-[#855DF6] via-[#7B5CF6] to-[#715EFE] shadow-lg relative overflow-hidden">
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-20 -mt-20 animate-pulse"></div>
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full -ml-12 -mb-12 animate-pulse"></div>
        <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2 animate-pulse"></div>
        
        <div className="relative z-10 px-4 md:px-7 py-6 md:py-8">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="p-2.5 bg-white/20 rounded-xl backdrop-blur-sm shadow-lg">
                <MdOutlineSubscriptions className="w-5 h-5 text-white md:w-6 md:h-6" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-white md:text-2xl dahboardFont tracking-tight">
                  Teachers Subscription
                </h2>
                <p className="text-sm text-white/70 hidden sm:block">
                  Manage teacher subscription plans
                </p>
              </div>
            </div>
            {/* <div className="flex items-center gap-2">
              <div className="flex items-center gap-2 px-3 py-1.5 bg-white/20 rounded-full backdrop-blur-sm">
                <FiRefreshCw className="w-3.5 h-3.5 text-white/70" />
                <span className="text-xs text-white/80">
                  {new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                </span>
              </div>
            </div> */}
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mt-5 md:gap-4">
            {statsCards.map((card, index) => (
              <div 
                key={index}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300 group"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-lg font-bold text-white uppercase md:text-lg">
                      {card.title}
                    </p>
                    <p className="text-xl font-bold text-white md:text-2xl mt-0.5">
                      {card.count}
                    </p>
                    {card.subtitle && (
                      <p className="text-[14px] text-white/40 hidden sm:block">
                        {card.subtitle}
                      </p>
                    )}
                  </div>
                  <div className={`p-2 rounded-xl bg-gradient-to-br ${card.color} bg-opacity-30 shadow-inner`}>
                    <card.icon className="w-4 h-4 text-white md:w-5 md:h-5" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <section className="px-3 py-4 -mt-4 md:px-6 lg:px-10 md:py-6">
        <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
          <div className="p-3 md:p-4">
            <ReferalTable
              TableName={`Teachers Subscription List`}
              TableHeader={referralThead}
              TableData={subscriptionListData}
              handleToggle={handleToggle}
              deleteAction={deleteAction}
              handleCreateModal={handleCreateReferal}
              keyword={keyword}
              setKeyword={setKeyword}
              pageNo={pageNo}
              setpageNo={setpageNo}
              viewAction={viewAction}
              size={size}
              total={subscriptionListTotal}
              setSize={setSize}
              handlePageClick={handlePageClick}
              currentSortKey={sortKey}
              currentSortOrder={sortOrder}
              onSort={handleSort}
            />
          </div>
        </div>
      </section>

      {/* Modals */}
      {isDeleteModal && (
        <SimpleDeleteModal
          isOpen={isDeleteModal}
          title={`Delete`}
          onCancel={toggleDeleteModal}
          onDelete={handleDelete}
        />
      )}

      {isCreateReferalModal && (
        <ReferalCreateModal
          onCancel={toggleReferalCreateModal}
          title={`Generate New Referral Code`}
          setCate={setCate}
          cate={cate}
          inputData={inputData}
          handleONChange={handleRewardOnChange}
          onSubmit={onSubmit}
          errors={errors}
        />
      )}

      {isCreateRewardModal && (
        <RewardCreateModal
          onCancel={toggleRewardCreateModal}
          title={`Add New Referral Reward`}
          inputData={rewardCreateInputs}
          handleONChange={handleOnChnage}
        />
      )}
    </div>
  )
}

export default TeachersSubscription
